import Vue from 'vue';
import { isBrowser } from '../utils/isBrowser';
import Router, { RouteConfig } from 'vue-router';

Vue.use(Router);

function createRouter() {
  let routes: RouteConfig[] = [];

  try {
    const context = require.context(`../pages`, true, /.*\/routes\.tsx?$/);
    context.keys().forEach((key: string) => {
      const route = context(key).default;
      routes = routes.concat(route);
    });
  } catch (err) {
    console.warn((err as Error).message);
  }

  routes.push({
    path: '/',
    redirect: '/index'
  });

  const router = new Router({
    routes,
    scrollBehavior() {
      return { x: 0, y: 0 };
    }
  });

  router.beforeEach((to: any, _, next) => {
    if (to.meta.title && isBrowser()) {
      document.title = to.meta.title;
    }
    next();
  });

  return router;
}

export default createRouter();
